import React, { Component } from 'react'
import api from '../../lib/Api'
import Select from 'react-select/lib/Async'
import PropTypes from 'prop-types'

export default class SelectLookup extends Component {
  static propTypes = {
    apiVersion: PropTypes.number,
    criteria: PropTypes.object,
    formatSuggestion: PropTypes.func.isRequired,
    isMulti: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    searchEndpoint: PropTypes.string.isRequired,
    searchField: PropTypes.string.isRequired,
    value: PropTypes.string,
  }

  static defaultProps = {
    criteria: {},
  }

  constructor(props) {
    super(props)

    this.lastRequestId = null
  }

  loadSuggestions = (value, cb) => {
    const inputValue = value.trim().toLowerCase()
    let suggestions = []

    if (inputValue.length < 4) return

    // Cancel the previous request
    if (this.lastRequestId !== null) {
      clearTimeout(this.lastRequestId)
    }

    const searchCriteria = {
      ...this.props.criteria,
      [this.props.searchField]: inputValue,
    }

    this.lastRequestId = setTimeout(() => {
      // Specifying the apiClient should be temporary here until we can replace
      // all of the api endpoints
      if (this.props.apiVersion === 2) {
        const searchEndpoint = `${this.props.searchEndpoint}?${this.props.searchField}=${inputValue}`
        api.get(searchEndpoint).then(({ data }) => {
          suggestions = data.map(result => {
            return this.props.formatSuggestion(result)
          })

          cb(suggestions)
        })
      } else {
        api.post(this.props.searchEndpoint, searchCriteria).then(({ data }) => {
          suggestions = data.map(result => {
            return this.props.formatSuggestion(result)
          })

          cb(suggestions)
        })
      }
    }, 1000)
  }

  render() {
    return (
      <Select
        cacheOptions
        isClearable
        isMulti={this.props.isMulti || false}
        loadOptions={this.loadSuggestions}
        onChange={this.props.onChange}
        openMenuOnClick={false}
        placeholder={this.props.placeholder}
        value={this.props.value}
      />
    )
  }
}

export const formatUserSuggestion = () => {
  return {
    value: user.email,
    label: `${user.email} - ${user.firstName} ${user.lastName}`,
    ...user,
  }
}

export const formatSchoolSuggestion = () => {
  return {
    value: school.mdrpid,
    label: `${school.name} - ${school.mdrpid}`,
    ...school,
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectLookup/SelectLookup.js